'use client';

import { c as _c } from "react/compiler-runtime";
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { env } from '@cc-shopping/platform-env';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { Button } from '@mui/material';
import type { CardFinderBranch } from './types';
type Props = {
  activityId: string;
  branch: CardFinderBranch;
};
export function CardfinderBranchCta(t0) {
  const $ = _c(12);
  const {
    activityId,
    branch
  } = t0;
  let t1;
  if ($[0] !== branch) {
    t1 = {
      branch_variant: branch
    };
    $[0] = branch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activityId || $[3] !== t1) {
    t2 = {
      actionName: "cc_recommend_flow",
      actionType: "click",
      actionSection: "ru_cardfinder_entry",
      additionalAttributes: t1,
      parentActivityId: activityId
    };
    $[2] = activityId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const firePageAction = usePageAction(t2);
  const t3 = `${env.NEXT_PUBLIC_NW_URL}/credit-cards/cardfinder/${branch}`;
  let t4;
  if ($[5] !== firePageAction) {
    t4 = () => firePageAction();
    $[5] = firePageAction;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      bgcolor: "lime.tintLP",
      color: "primary.main",
      borderRadius: 1,
      py: 1.5,
      px: 4,
      letterSpacing: "0.05em",
      lineHeight: 1.5,
      boxShadow: "none",
      fontWeight: 700,
      "&:hover": {
        bgcolor: "lime.main",
        boxShadow: "none"
      }
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowForwardOutlinedIcon sx={{
      fontSize: 12,
      marginLeft: 1,
      color: "primary.main"
    }} aria-hidden={true} />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t4) {
    t7 = <Button href={t3} onClick={t4} variant="contained" component="a" fullWidth={true} sx={t5}>GET MATCHED{t6}</Button>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}